<template>
  <div id="room-item-create">
    <info-box v-bind:description="description"></info-box>
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>
    <span v-if="notification">{{notification}}</span> 
    <div>
      <div><router-link class="nav-link" to="/room-item-management">Back to list</router-link></div>
      <div v-if="existingItem">Editing Existing Item: {{existingItem.id}}</div>
      <div v-else>Creating New Item</div>
      <div v-if="existingItem"><button @click="giveMeItem">Give Me This Item</button></div>
      <div style="display: inline-block; vertical-align: super;">
        <div ref="roomcontainer" id="room-container" style="width:500px;float:right;"></div>
        <table class="editor-table">
          <tr><th>Name</th><th>Value</th><th style="width:250px;">Desc</th></tr>
          <tr><td>Item Type</td><td>
            <select v-model="selectedItemType">
              <option>3d</option>
              <option value="wall">poster</option>
              <option value="rug">rug</option>
              <option>2d</option>
              <option>wallBase</option>
              <option>floorBase</option>
            </select>
          </td><td>Type of item</td></tr>
          <tr><td>Zip Optimization</td><td>
            <file-upload
              v-if="!files[0]"
              ref="uploadOptimize"
              input-id="uploadOptimize"
              v-model="fileToOptimize"
            >
              <button v-if="!fileToOptimize[0]">Upload File To Optimize</button>
              <span v-else>{{fileToOptimize[0].name}}</span>
            </file-upload><button v-if="fileToOptimize[0] && !files[0]" @click="sendOptimize">Optimize Zip</button>
          </td><td>Use this only if you have a zip (only tested with sketchFab gltf zips)</td></tr>
          <tr><td>Model/Texture File</td><td>
            <file-upload
              ref="upload1"
              input-id="upload1"
              v-model="files"
            >
              <button v-if="!files[0]">Upload Model/Texture File</button>
              <span v-else>{{files[0].name}}</span>
            </file-upload>
          </td><td><img v-if="isTextureItem(itemType)" :src="assetUrl" style="width:100px;"/></td></tr>
          <tr><td>Thumbnail Image</td><td>
            <!-- <file-upload
              ref="upload2"
              input-id="upload2"
              v-model="thumbnailImage"
            >
              Upload file
            </file-upload> -->
            <button @click="takeThumbnail">Snap Thumbnail</button>
          </td><td><img v-if="thumbnailUrl" :src="thumbnailUrl" style="width:100px;"/></td></tr>
          <tr v-if="!is2dItem(itemType)"><td>TOTAL TRIANGLES:</td><td>{{itemTriangles}}</td><td>Lower the better ~100-5000</td></tr>
          <tr v-if="files[0]"><td>FILE SIZE:</td><td>{{files[0].size}}</td><td>Lower the better ~100000 (100k) to 5000000 (5mb)</td></tr>
          <tr v-if="showColor"><td>Color</td><td><input type="color" align="center" v-model="color"/> {{color}}</td><td></td></tr>
          <tr v-if="showRoughness"><td>Roughness</td><td><input type="text" placeholder="Enter Number" align="center" v-model="roughness"/></td><td>Between 0-1 ie 0.5</td></tr>
          <tr v-if="showMetalness"><td>Metalness</td><td><input type="text" placeholder="Enter Number" align="center" v-model="metalness"/></td><td>Between 0-1 ie 0.5</td></tr>
          <tr v-if="showBumpMap"><td>Bump Map</td><td><file-upload
              ref="upload3"
              input-id="upload3"
              v-model="bumpMapFile"
            >
              <button v-if="!bumpMapFile[0]">Upload Bump File</button>
              <span v-else>{{bumpMapFile[0].name}}</span>
            </file-upload></td><td><img v-if="bumpMapFileName" :src="lootItemItemUrl(bumpMapFileName)" style="width:100px;"/></td></tr>
          <tr v-if="showNormalMap"><td>Normal Map</td><td><file-upload
              ref="upload4"
              input-id="upload4"
              v-model="normalMapFile"
            >
              <button v-if="!normalMapFile[0]">Upload Normal Map File</button>
              <span v-else>{{normalMapFile[0].name}}</span>
            </file-upload></td><td>{{normalMapFileName}}<img v-if="normalMapFileName !== undefined" :src="lootItemItemUrl(normalMapFileName)" style="width:100px;"/></td></tr>
          <tr v-if="showBumpScale"><td>Bump/Normal Scale</td><td><input type="text" placeholder="Enter Number" align="center" v-model="bumpScale"/></td><td></td></tr>
          <tr v-if="!is2dItem(itemType)"><td>scaleFactor</td><td><input type="text" placeholder="Enter Number" align="center" v-model="scaleFactor"/></td><td>How big. To make smaller go between 0.01 and 1. Bigger > 1</td></tr>
          <tr v-if="is2dItem(itemType)"><td>width</td><td><input type="text" placeholder="Enter Number" align="center" v-model="itemSize"/></td><td>How wide. In centimeters.</td></tr>
          <tr v-if="itemType === '2d'"><td>depth</td><td><input type="text" placeholder="Enter Number" align="center" v-model="itemDepth"/></td><td>How deep. In centimeters.</td></tr>
          <tr v-if="itemType === '2d'"><td>height</td><td><input type="text" placeholder="Enter Number" align="center" v-model="itemHeight"/></td><td>How high (usually can leave blank). In centimeters.</td></tr>
          <tr v-if="!is2dItem(itemType)"><td>iRotationY</td><td><input type="text" placeholder="Enter Number" align="center" v-model="iRotationY"/></td><td>The way it is facing in degrees</td></tr>
          <tr><td>Name</td><td><input type="text" placeholder="Enter" align="center" v-model="itemName"/></td><td></td></tr>
          <tr><td>Rarity</td><td>
            <select v-model="itemRarity">
              <option>common</option>
              <option>uncommon</option>
              <option>rare</option>
              <option>legendary</option>
              <option>exotic</option>
            </select>  
          </td><td></td></tr>
          <tr><td>For Sale?</td><td>
            <select v-model="itemForSale">
              <option v-bind:value="true">true</option>
              <option v-bind:value="false">false</option>
            </select>
          </td><td></td></tr>
          <tr><td>Price</td><td><input type="text" placeholder="Enter" align="center" v-model="itemPrice"/></td><td></td></tr>
          <tr><td>Currency Type</td><td>
            <select v-model="itemPriceCurrencyType">
              <option>sb</option>
              <option value="mt">mt (gold)</option>
            </select>
          </td><td></td></tr>
          <tr><td>Description</td><td><input type="text" placeholder="Enter" align="center" v-model="itemDescription"/></td><td></td></tr>
          <tr><td>Max Allowed</td><td><input type="text" placeholder="Enter" align="center" v-model="itemMaxAllowed"/></td><td></td></tr>
          <tr><td>Sub Category 1</td><td>
            <select v-model="itemSubCategory1">
              <option value="">none</option>
              <option v-for="item in subCategory1Options" :key="item">{{item}}</option>
            </select>
          </td><td></td></tr>
          <tr><td>Sub Category 2</td><td>
            <select v-model="itemSubCategory2">
              <option value="">none</option>
              <option v-for="item in subCategory2Options" :key="item">{{item}}</option>
            </select>  
          </td><td></td></tr>
          <tr><td>Collection</td><td>
            <select v-model="itemCollection1">
              <option value="">none</option>
              <option v-for="item in collection1Options" :key="item">{{item}}</option>
            </select>  
          </td><td></td></tr>
          <tr><td>Sketchfab Attribution Import</td><td><input type="text" placeholder="Enter" align="center" v-model="sketchFabId"/><br/><button @click="fetchSketch">Sketchfab Fetch</button></td><td>Enter the SketchFab ID here. Example: 61fc4b5c337f4169a5e26e1c40e92e28</td></tr>
          <tr><td>Attribution Author</td><td><input type="text" placeholder="Enter" align="center" v-model="itemAttributionAuthor"/></td><td></td></tr>
          <tr><td>Attribution Author URL</td><td><input type="text" placeholder="Enter" align="center" v-model="itemAttributionAuthorUrl"/></td><td></td></tr>
          <tr><td>Attribution Title</td><td><input type="text" placeholder="Enter" align="center" v-model="itemAttributionTitle"/></td><td></td></tr>
          <tr><td>Attribution Title URL</td><td><input type="text" placeholder="Enter" align="center" v-model="itemAttributionTitleUrl"/></td><td></td></tr>
          <tr><td>Attribution License</td><td>
            <select v-model="itemAttributionLicense">
              <option value>none</option>
              <option>CC BY 4.0</option>
            </select>  
          </td><td>{{itemAttributionLicenseUrl}}</td></tr>
          <tr><td colspan=3 style="text-align:center;"><button @click="save">Save</button></td></tr>
        </table>
      </div>
    </div>
    <div style="font-size:12px">All items VIRTUAL. You are not buying physical items!</div>
    <span class="copyright">All product names, logos, and brands are property of their respective owners. All company, product and service names used in this website are for identification purposes only. Use of these names, logos, and brands does not imply endorsement.</span>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import VueUploadComponent from 'vue-upload-component'
// import BigNumber from 'BigNumber.js'
import router from '../router'
import axios from 'axios'

let scriptLoaded = false
let scriptFinished = false

function initialState () {
  return {
    subCategory1Options: ['furniture', 'poster', 'electronics', 'accessories', 'wallBase', 'floorBase', 'appliances'],
    subCategory2Options: ['emote', 'banner', 'art', 'tvs', 'tv stands', 'lights', 'bottles', 'tables', 'random', 'fans', 'misc', 'accessories'],
    collection1Options: ['halloween', 'valentines', 'summer', 'pool', 'winter'],
    files: [],
    thumbnailImage: [],
    bumpMapFile: [],
    normalMapFile: [],
    fileToOptimize: [],
    title_img: 'swiftorland-title.svg',
    description: {
      title: 'Room Item Management',
      text: `Do it!`
    },
    roomDisplayed: false,
    room: undefined,
    roomManager: undefined,
    roomObject: undefined,
    roomObjectMap: {},
    wallParams: {},
    floorParams: {},
    scaleFactor: 1,
    itemSize: 100,
    color: undefined,
    normalMap: undefined,
    roughness: undefined,
    metalness: undefined,
    bumpScale: undefined,
    iRotationY: 0,
    notification: undefined,
    initialTriangles: 0,
    triangles: 0,
    selectedItemType: '3d',
    itemName: '',
    itemRarity: 'common',
    itemDescription: '',
    itemForSale: false,
    itemPrice: '50',
    itemPriceCurrencyType: 'mt',
    itemMaxAllowed: '5',
    itemSubCategory1: '',
    itemSubCategory2: '',
    itemCollection1: '',
    itemAttributionAuthor: '',
    itemAttributionAuthorUrl: '',
    itemAttributionTitle: '',
    itemAttributionTitleUrl: '',
    itemAttributionLicense: '',
    sketchFabId: undefined,
    itemDepth: 100,
    itemHeight: undefined,
    existingThumbnailUrl: undefined,
    thumbnailSnapshot: undefined,
    existingItem: undefined,
    fileId: undefined,
    displaying: true
  }
}

/* global SwiftorRooms */

export default {
  name: 'room-item-editor',
  props: ['itemId'],
  components: {
    VueUploadComponent
  },
  async mounted () {
    await this.refreshLootItems()
  },
  created: async function () {
    this.loadPage()
  },
  data () {
    return initialState()
  },
  computed: Object.assign(mapState(['currentUser', 'lootShopLootItemIds', 'lootShopLootItems']), {
    itemType () {
      if (this.selectedItemType === 'rug') {
        return 'wall'
      } else {
        return this.selectedItemType
      }
    },
    thumbnailUrl () {
      if (this.thumbnailImage.length > 0) {
        return URL.createObjectURL(this.thumbnailImage[0].file)
      } else if (this.thumbnailSnapshot) {
        return URL.createObjectURL(this.thumbnailSnapshot)
      } else if (this.existingItem) {
        return `${Vue.config.WEB_ASSET_BASE_URL}/${this.existingItem.image_url}`
      }
    },
    assetUrl () {
      if (this.files.length > 0) {
        return URL.createObjectURL(this.files[0].file)
      } else if (this.existingItem && this.existingItem.meta && this.existingItem.meta.texture) {
        if (typeof this.existingItem.meta.texture === 'string') {
          return `${Vue.config.ITEM_ASSET_BASE_URL}/${this.existingItem.meta.texture}`
        } else {
          return `${Vue.config.ITEM_ASSET_BASE_URL}/${this.existingItem.meta.texture.map}`
        }
      }
    },
    itemTriangles () {
      if (this.triangles === 0) {
        return 0
      }
      return this.triangles - this.initialTriangles
    },
    itemAttributionLicenseUrl () {
      if (this.itemAttributionLicense === 'CC BY 4.0') {
        return 'https://creativecommons.org/licenses/by/4.0/'
      } else {
        return undefined
      }
    },
    showScaleFactor () {
      return true
    },
    showColor () {
      return this.isTextureItem(this.itemType)
    },
    showNormalMap () {
      return this.isTextureItem(this.itemType)
    },
    showRoughness () {
      return this.isTextureItem(this.itemType)
    },
    showMetalness () {
      return this.isTextureItem(this.itemType)
    },
    showBumpMap () {
      return this.isTextureItem(this.itemType)
    },
    showBumpScale () {
      return this.isTextureItem(this.itemType)
    },
    assetFileName () {
      if (this.existingItem) {
        if (this.existingItem.meta && this.existingItem.meta.texture && this.existingItem.meta.texture.map) {
          return this.existingItem.meta.texture.map
        }
      }

      return undefined
    },
    bumpMapFileName () {
      if (this.existingItem) {
        if (this.existingItem.meta && this.existingItem.meta.texture && this.existingItem.meta.texture.bump) {
          return this.existingItem.meta.texture.bump
        }
      }

      return undefined
    },
    normalMapFileName () {
      if (this.existingItem) {
        if (this.existingItem.meta && this.existingItem.meta.texture && this.existingItem.meta.texture.normalMap) {
          return this.existingItem.meta.texture.normalMap
        }
      }

      return undefined
    }
  }),
  methods: {
    async loadPage () {
      if (this.roomManager) {
        this.roomManager.quit()
        this.roomManager = undefined
        // this.roomManager.room.removeRoomObject(this.roomObject.uuid)
      }
      Object.assign(this.$data, initialState())
      if (this.itemId) {
        this.$store.dispatch('fetchLootItem', this.itemId).then(() => {
          let item = this.$store.state.lootItems[this.itemId]
          this.existingItem = item
          this.itemName = item.name
          this.itemRarity = item.rarity
          this.itemDescription = item.description
          this.itemForSale = item.for_sale
          this.itemPrice = item.price
          this.itemPriceCurrencyType = item.price_currency_type
          this.itemMaxAllowed = item.max_allowed
          this.itemSubCategory1 = item.sub_category1
          this.itemSubCategory2 = item.sub_category2
          this.itemCollection1 = item.collection1
          this.itemAttributionAuthor = item.attribution_author
          this.itemAttributionAuthorUrl = item.attribution_author_url
          this.itemAttributionTitle = item.attribution_title
          this.itemAttributionTitleUrl = item.attribution_title_url
          this.itemAttributionLicense = item.attribution_license
          // this.itemAttributionLicenseUrl = item.attribution_license_url
          this.existingThumbnailUrl = item.image_url
          this.selectedItemType = item.meta.objectType

          if (item.meta && item.meta.onWall === 'floor') {
            this.selectedItemType = 'rug'
          }

          if (item.meta.scaleFactor) {
            this.scaleFactor = item.meta.scaleFactor
          }

          if (item.meta.iRotationY) {
            this.iRotationY = item.meta.iRotationY
          }

          if (item.meta.size) {
            this.itemSize = item.meta.size[0]
            this.itemHeight = item.meta.size[1]
            this.itemDepth = item.meta.size[2]
          }

          if (item.meta.width) {
            this.itemSize = item.meta.width
          }

          if (item.meta.height) {
            this.itemHeight = item.meta.height
          }

          if (item.meta.depth) {
            this.itemDepth = item.meta.depth
          }

          if (item.meta.objectType === '3d') {
            this.fileId = item.meta.modelParams.gltf
          } else if (typeof item.meta.texture === 'string') {
            this.fileId = item.meta.texture
          } else if (this.is2dItem(item.meta.objectType)) {
            this.fileId = item.meta.texture.map
          }

          if (this.isTextureItem(item.meta.objectType)) {
            if (item.meta.texture) {
              this.color = item.meta.texture.color
              this.scaleFactor = item.meta.texture.scaleFactor
              this.roughness = item.meta.texture.roughness
              this.metalness = item.meta.texture.metalness
              if (item.meta.texture.bumpScale !== undefined) {
                this.bumpScale = parseInt(item.meta.texture.bumpScale)
              } else if (item.meta.texture.normalScale !== undefined) {
                this.bumpScale = parseInt(item.meta.texture.normalScale[0])
              }
            }
          }

          this.loadScript()
        })
      } else {
        // await Vue.nextTick()
        this.existingItem = undefined
        return this.loadScript()
      }
    },
    loadScript () {
      // if (scriptLoaded) {
      //   scriptLoaded.innerHTML = ''
      //   scriptLoaded = undefined
      // }
      if (!scriptLoaded) {
        let roomScript = document.createElement('script')
        roomScript.setAttribute('src', Vue.config.ROOM_JS_URL)
        document.head.appendChild(roomScript)

        roomScript.onload = () => {
          scriptFinished = true

          this.displayRoom()
        }

        scriptLoaded = roomScript
      } else {
        this.displayRoom()
      }

      this.roomScript = scriptLoaded
    },
    async refreshLootItems () {
      this.$store.dispatch('fetchLootShopLootItems')
    },
    lootShopLootItemForId (id) {
      return this.$store.state.lootShopLootItems[id]
    },
    lootItemImageUrl (lootItem) {
      if (lootItem.meta && (lootItem.meta.objectType === 'wallBase' || lootItem.meta.objectType === 'floorBase')) {
        // TODO: WAT
        return this.lootItemItemUrl(this.assetFileName) // `${Vue.config.ITEM_ASSET_BASE_URL}/${prefix}${prefix !== '' ? '_' : ''}${file}`
      } else {
        return `${Vue.config.WEB_ASSET_BASE_URL}/${lootItem.image_url}`
      }
    },
    lootItemItemUrl (file, prefix = '') {
      return `${Vue.config.ITEM_ASSET_BASE_URL}/${prefix}${prefix !== '' ? '_' : ''}${file}`
    },
    currencyIcon (priceCurrencyType) {
      let image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png'

      return `${Vue.config.WEB_ASSET_BASE_URL}/${image}`
    },
    attributionText (lootItem) {
      if (!lootItem.attribution_author) { return }
      // // "Creative Commons 10th Birthday Celebration San Francisco" by tvol is licensed under CC BY 2.0
      return `<a href="${lootItem.attribution_title_url}" target="_blank">"${lootItem.attribution_title}"</a> by <a href="${lootItem.attribution_author_url}" target="_blank">${lootItem.attribution_author}</a> <br/> Licensed under <a href="${lootItem.attribution_license_url}" target="_blank">${lootItem.attribution_license}</a>`
    },
    requiresAttribution (lootItem) {
      return !!lootItem.attribution_author
    },
    notify (text) {
      this.notification = text
      setTimeout(() => {
        this.notification = undefined
      }, 5000)
    },
    async displayRoom () {
      if (!this.$refs.roomcontainer) {
        await this.sleep(1000)
      }
      // document.getElementById('room-container').innerHTML = ''
      if (this.$refs.roomcontainer) { this.$refs.roomcontainer.innerHTML = '' }
      if (!scriptFinished) {
        return
      } else {

      }
      this.displaying = true
      this.roomManager = undefined
      this.roomObjectMap = {}
      this.room = {meta: {}}

      this.roomManager = new SwiftorRooms.RoomManager(Object.assign({
        container: this.$refs.roomcontainer, // document.getElementById('room-container'),
        assetBaseUrl: Vue.config.ITEM_ASSET_BASE_URL,
        editable: this.editable,
        isMobile: false
      }))
      this.roomManager.start()

      let roomParams = {}

      if (this.itemType === 'wallBase') {
        let wall = {texture: this.existingItem.meta.texture}

        roomParams.wallParams = {left: wall, right: wall, front: wall, back: wall}
      } else if (this.itemType === 'floorBase') {
        let floor = {texture: this.existingItem.meta.texture}
        // floor.texture.bump = undefined
        roomParams.floorParams = floor
      }
      // await this.roomManager.loadRoom(this.room.meta)
      await this.roomManager.loadRoom(roomParams)
      // this.addToRoom(ri, ri.loot_item)
      this.roomManager.gameLoop()

      this.roomDisplayed = 'ya' // this.user.id

      if (this.existingItem) {
        setTimeout(() => {
          this.roomObject = this.roomManager.room.addRoomObject(this.existingItem.meta)
          setTimeout(() => {
            this.triangles = this.roomManager.renderer.info.render.triangles
            this.displaying = false
          }, 1000)
        }, 1000)
      } else {
        this.displaying = false
      }
      setTimeout(() => {
        this.initialTriangles = this.roomManager.renderer.info.render.triangles
      }, 1000)
    },
    readFileToDataURL (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    baseMeta () {
      let base = {
        objectType: this.itemType
      }

      if (this.itemType === '3d') {
        base.iRotationY = parseInt(this.iRotationY) ? this.iRotationY : 0
        base.scaleFactor = this.scaleFactor
      } else if (this.is2dItem(this.itemType)) {
        if (this.itemSize && this.itemSize.toString() !== '') {
          if (!base.size) { base.size = [] }
          base.size[0] = parseInt(this.itemSize)
        }

        if (this.itemType !== 'wall' && this.itemHeight && this.itemHeight.toString() !== '') {
          if (!base.size) { base.size = [] }
          base.size[1] = parseInt(this.itemHeight)
        }

        if (this.itemType !== 'wall' && this.itemDepth && this.itemDepth.toString() !== '') {
          if (!base.size) { base.size = [] }
          base.size[2] = parseInt(this.itemDepth)
        }

        if (this.selectedItemType === 'rug') {
          base.onWall = 'floor'
        }

        base.autoFaceCamera = this.itemType !== 'wall'
      }

      if (this.isTextureItem(this.itemType)) {
        base.texture = {}
        if (this.scaleFactor && this.scaleFactor.toString() !== '0') { base.texture.scaleFactor = this.scaleFactor }
        if (this.metalness && this.metalness.toString() !== '0') { base.texture.metalness = this.metalness }
        if (this.roughness && this.roughness.toString() !== '0') { base.texture.roughness = this.roughness }
        if (this.bumpScale && this.bumpScale.toString() !== '0') {
          let local = this.localMeta()

          if (local.texture.bump) {
            base.texture.bumpScale = parseInt(this.bumpScale)
          } else if (local.texture.normalMap) {
            base.texture.normalScale = [parseInt(this.bumpScale), parseInt(this.bumpScale)]
          }
        }
        if (this.color && this.color.toString() !== '') { base.texture.color = this.color }
      }

      return base
    },
    localMeta () {
      let url
      if (this.files[0] && this.files[0].file) {
        url = URL.createObjectURL(this.files[0].file)
      } else {
        url = this.fileId
      }

      if (this.itemType === '3d') {
        return {modelParams: {gltf: url}}
      } else if (this.isTextureItem(this.itemType)) {
        let local = { texture: {} }
        if (url) { local.texture.map = url }

        if (this.bumpMapFile[0] && this.bumpMapFile[0].file) {
          local.texture.bump = URL.createObjectURL(this.bumpMapFile[0].file)
        } else if (this.bumpMapFileName) {
          local.texture.bump = this.bumpMapFileName
        }

        if (this.normalMapFile[0] && this.normalMapFile[0].file) {
          local.texture.normalMap = URL.createObjectURL(this.normalMapFile[0].file)
        } else if (this.normalMapFileName) {
          local.texture.normalMap = this.normalMapFileName
        }

        return local
      } else {
        console.log('Error no local meta')
        return {}
      }
    },
    combinedMeta () {
      let base = this.baseMeta()
      let local = this.localMeta()

      let combined = {...base, ...local}
      if (this.isTextureItem(this.itemType)) { combined.texture = {...base.texture, ...local.texture} }
      if (this.itemType === '3d') { combined.modelParams = {...base.modelParams, ...local.modelParams} }

      return combined
    },
    async refreshItem () {
      if (this.refreshWaiting === true || this.displaying === true) {
        return
      }

      if (!this.roomManager) {
        return
      }
      await Vue.nextTick()
      // let wat = await this.readFileToDataURL(this.files[0].file)
      if (this.roomObject) {
        if (!this.roomObject.uuid) {
          this.refreshWaiting = true
          await this.sleep(100)
          this.refreshWaiting = false
          // return
        }
        if (this.roomManager && this.roomObject && this.roomObject.uuid) {
          this.roomManager.room.removeRoomObject(this.roomObject.uuid)
          this.roomObject = undefined
        } else if (this.roomObject) {
          return
        }
      }

      if (!this.is2dItem(this.itemType) && isNaN(parseInt(this.scaleFactor))) {
        return
      }

      if (this.itemType === 'wallBase') {
        let wall = this.combinedMeta() // {...this.baseMeta(), ...this.localMeta()}
        this.roomManager.room.createWall('left', wall)
        this.roomManager.room.createWall('right', wall)
        this.roomManager.room.createWall('front', wall)
        this.roomManager.room.createWall('back', wall)
      } else if (this.itemType === 'floorBase') {
        // TODO: Add floor
        let floor = this.combinedMeta() // {...this.baseMeta(), ...this.localMeta()}
        // floor.texture = {...this.baseMeta().texture, ...this.localMeta().texture}
        this.roomManager.room.createFloor(floor)
      } else if (!this.isBaseItem(this.itemType)) {
        if (this.fileId || (this.files && this.files[0])) {
          this.roomObject = this.roomManager.room.addRoomObject(this.combinedMeta())
          setTimeout(() => {
            if ((this.files && this.files[0])) {
              if (this.roomObject && this.roomObject.size.x < 10) {
                this.scaleFactor = parseInt(50 / this.roomObject.size.x)
              }
            }
            this.triangles = this.roomManager.renderer.info.render.triangles
          }, 1000)
        }
      }
    },
    async takeThumbnail () {
      this.roomManager.render()
      this.thumbnailSnapshot = await this.getCanvasBlob(this.roomManager.renderer.domElement)
      return this.thumbnailSnapshot
    },
    async save () {
      let thumbnail
      if (!this.existingThumbnailUrl && this.thumbnailImage.length === 0 && !this.thumbnailSnapshot) { // } && this.itemType === '3d') {
        // thumbnail = await this.getCanvasBlob(this.roomManager.renderer.domElement)
        await this.takeThumbnail()
      }

      if (this.thumbnailFile) {
        thumbnail = this.thumbnailFile[0].file
      } else if (this.thumbnailSnapshot) {
        thumbnail = this.thumbnailSnapshot
      }
      // } else if (!this.thumbnailUrl && this.files[0] && (this.itemType === 'floorBase' || this.itemType === 'wallBase')) {
      //   thumbnail = this.files[0].file
      // }
      let formData = new FormData()

      if (this.files[0]) { formData.append('itemFile', this.files[0].file) }
      if (thumbnail) { formData.append('thumbnailFile', thumbnail) }
      formData.append('item_type', this.itemType)
      formData.append('base_meta', JSON.stringify(this.baseMeta()))
      formData.append('name', this.itemName)
      formData.append('price', this.itemPrice)
      formData.append('rarity', this.itemRarity)
      formData.append('description', this.itemDescription)
      formData.append('for_sale', this.itemForSale)
      formData.append('price_currency_type', this.itemPriceCurrencyType)
      formData.append('max_allowed', this.itemMaxAllowed)
      formData.append('sub_category1', this.formValue(this.itemSubCategory1))
      formData.append('sub_category2', this.formValue(this.itemSubCategory2))
      formData.append('collection1', this.formValue(this.itemCollection1))
      formData.append('attribution_author', this.formValue(this.itemAttributionAuthor))
      formData.append('attribution_author_url', this.formValue(this.itemAttributionAuthorUrl))
      formData.append('attribution_title', this.formValue(this.itemAttributionTitle))
      formData.append('attribution_title_url', this.formValue(this.itemAttributionTitleUrl))
      formData.append('attribution_license', this.formValue(this.itemAttributionLicense))
      formData.append('attribution_license_url', this.formValue(this.itemAttributionLicenseUrl))

      if (this.bumpMapFile[0]) { formData.append('bumpMapFile', this.bumpMapFile[0].file) }
      if (this.normalMapFile[0]) { formData.append('normalMapFile', this.normalMapFile[0].file) }

      let response

      if (this.existingItem) {
        response = await axios.put(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/room-items/${this.existingItem.id}`, formData, {withCredentials: true})
      } else {
        response = await axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/room-items`, formData, {withCredentials: true})
      }

      if (response.data) {
        // this.notify('Room Saved.')
        let id = response.data.loot_item.id

        router.push({ name: 'RoomItemEditor', query: { notify: 'Item Saved.' }, params: { itemId: id } })
      } else {
        this.notify('ERROR SAVING.')
      }
    },
    async giveMeItem () {
      await axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/room-items/giveMe`, {
        lootItemId: this.existingItem.id
      }, {withCredentials: true})

      this.notify('OK')
    },
    formValue (v) {
      return v && v !== '' ? v : ''
    },
    getCanvasBlob (canvas) {
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          resolve(blob)
        })
      })
    },
    isTextureItem (itemType) {
      return ['wallBase', 'floorBase', 'wall', '2d'].includes(itemType)
    },
    isBaseItem (itemType) {
      return ['wallBase', 'floorBase'].includes(itemType)
    },
    is2dItem (itemType) {
      return ['wall', '2d'].includes(itemType)
    },
    async sendOptimize () {
      let formData = new FormData()

      if (this.fileToOptimize[0]) { formData.append('files', this.fileToOptimize[0].file) }

      let response = await axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/room-item-tools/optimize`, formData, {responseType: 'blob', withCredentials: true})

      if (response.data) {
        let d = new Blob([response.data])
        if (this.files.length === 0) {
          this.files.push({file: d, name: 'optimized.glb', size: d.size})
        } else {
          Vue.set(this.files[0], 'file', d)
          Vue.set(this.files[0], 'name', 'optimized.glb')
          Vue.set(this.files[0], 'size', d.size)
        }
      }
    },
    async fetchSketch () {
      let response = await axios.get(`https://api.sketchfab.com/v3/models/${this.sketchFabId}`)

      if (response && response.data && response.data.user) {
        this.itemAttributionAuthor = response.data.user.displayName
        this.itemAttributionAuthorUrl = response.data.user.profileUrl
        this.itemAttributionTitle = response.data.name
        this.itemAttributionTitleUrl = response.data.viewerUrl

        if (!this.itemName || this.itemName === '') {
          this.itemName = this.itemAttributionTitle
        }

        if (response.data.license && response.data.license.url === 'http://creativecommons.org/licenses/by/4.0/') {
          this.itemAttributionLicense = 'CC BY 4.0'
        } else {
          this.notify('WARNING: Unknown Sketchfab License')
        }
      } else {
        this.notify('Error Fetching SketchFab')
      }
    }
  },
  watch: {
    async files () {
      this.refreshItem()
    },
    '$route.params.itemId': function (id) {
      this.loadPage()
    },
    scaleFactor () {
      this.refreshItem()
    },
    itemSize () {
      this.refreshItem()
    },
    iRotationY () {
      this.refreshItem()
    },
    color () {
      this.refreshItem()
    },
    metalness () {
      this.refreshItem()
    },
    roughness () {
      this.refreshItem()
    },
    bumpScale () {
      this.refreshItem()
    },
    normalMapFile () {
      this.refreshItem()
    },
    bumpMapFile () {
      this.refreshItem()
    },
    itemId (nv, ov) {
      if (this.itemId) {
        this.$store.dispatch('fetchLootItem', this.itemId)
      }
    }
  }
}
</script>

<style scoped>
  .rarity-common {
    color: rgb(255, 255, 255);
  }

  .rarity-uncommon {
    color: rgb(17, 116, 14);
  }

  .rarity-rare {
    color: rgb(51, 81, 212);
  }

  .rarity-legendary {
    color: rgb(190, 34, 204);
  }

  .rarity-exotic {
    color: rgb(228, 197, 21);
  }
  .shop-image {
    max-width: 200px;
    max-height:200px;
  }

  .shop-item {
    width: 200px;
  }

  .currency-icon {
    max-width:20px;
    padding-left: 5px;
  }

  .price-content {
    display: flex; 
    align-items: center;  
    justify-content: center;
  }

  .btn-enabled{
    width:100%;
    display: inline-block;
    border-top: 4px #b62626 solid;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
    transition: background-color 0.2s , border-color 0.2s;
    margin: 5px;
    min-width: 50px;
    user-select: none;
    color:white;

    background-color: #5A3E85;
    height: 40px;
    margin-top: 5px;
    border-radius: 5px;
    border-top: 2px rgb(126, 85, 187) solid;
    padding: 0px 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn-enabled:hover{
    background-color: #b62626;
    border-top: 4px rgb(255, 0, 0) solid;
}
.btn-selected{
  background-color: #b62626;
    border-top: 4px rgb(255, 0, 0) solid;
}

tr:nth-child(even){
  background-color:#5a5a61;
}
tr:nth-child(odd){
  background-color:#484444;
}

.editor-table {
  padding:10px;margin:15px;width:unset;border:1px solid white;text-align:left;
  border-spacing: 1px;
}

</style><style>
#room-container {
    min-height: 500px;
    outline: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0); /* mobile webkit */
    margin:15px;
  }

  #room-container canvas {
    outline: none; border: 1px solid white;

  }

a {
  text-decoration: none;
  color: #445278;
}

a:visited {
  color: #4d566e;
}

a:hover {
  color: #62729c;
}

</style>


// WEBPACK FOOTER //
// src/components/Room-Item-Editor.vue